module.exports = __webpack_public_path__ + "static/media/Swiss-721-Black-No-2-BT.416f6be5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Swiss-721-Black-No-2-BT.ttf
// module id = 1082
// module chunks = 0 1 2 3 4 5 6 7